import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { IstStudyTeamOrganizationViewModalComponent } from './ist-study-team-organization-view-modal/ist-study-team-organization-view-modal.component';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { IstDataShareService } from '../../../services/ist/ist-datashare.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { CommonService } from '../../../services/common.service';
import { UserService } from '../../../services/user.service';
import { Subject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ist-study-team-organization',
  templateUrl: './ist-study-team-organization.component.html',
  styleUrls: ['./ist-study-team-organization.component.scss']
})
export class IstStudyTeamOrganizationComponent implements OnInit {

  columnDefs;
  operations;
  tempoperation;
  gridApi: GridApi;
  selectedRow;
  rowData;
  collapesedOrNot: any;
  ApplicationID: string;
  organisationType = [];
  StudyTeamOrganization: UntypedFormGroup;
  permission: string = "";
  IsMultipermission: string = "yes";
  userType: string = "";
  staticformFields: any;
  action: Subject<any> = new Subject();
  SCREEN_MODEL: any = null;
  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: IstSummaryService,
    private modalService: NgbModal,
    private datashareService: IstDataShareService,
    private commonService: CommonService,
    private userService: UserService,
  ) {
  }

  ngOnInit() {
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });

    this.StudyTeamOrganization = new UntypedFormGroup({
      NAME: new UntypedFormControl(null),
      TYPE: new UntypedFormControl(null),
      PhoneNumber: new UntypedFormControl("", [Validators.pattern("^[0-9]*$"),
      Validators.maxLength(100)]),
    });
    this.permission = this.commonService.getPagePermission("IST03").toLowerCase();

    if (this.permission == null || this.permission == undefined || this.permission == '') {
      const intervalId = setInterval(() => {
        this.permission = this.commonService.getPagePermission("IST03").toLowerCase();
        if (this.permission != null && this.permission != undefined && this.permission != '') {
            this.setSummaryData();
          clearInterval(intervalId);
        }
      }, 1000);
    }
    else{
       this.setSummaryData();
    }
   
    this.getStaticFiledsData('SCR-003');
    this.GetScreenConfigControls('SCR-003');
    this.rowData = [];

    this.userType = this.userService.getUserType();
    this.IstOrggetMasterData();
  }

  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode, this.ApplicationID)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
        this.columnDefs = [
          {
            "headerName": this.staticformFields?.NAME.LABEL_NAME,
            "field": "NAME"
          },
          {
            "headerName": this.staticformFields?.TYPE.LABEL_NAME,
            "field": "TYPE"
          },
          {
            "headerName": this.staticformFields?.PHONE.LABEL_NAME,
            "field": "PhoneNumber"
          }
        ];
      });
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
    const ModelRef = this.modalService.open(IstStudyTeamOrganizationViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    ModelRef.componentInstance.Content = {
      heading: 'View',
      content: { id: event.data['ID'], ApplicationID: this.ApplicationID }
    }
  }

  add() {
    let modalRef = this.modalService.open(IstStudyTeamOrganizationViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Add',
      content: { id: '', ApplicationID: this.ApplicationID }
    }
    modalRef.result.then(result => {
      this.setSummaryData();
    })    
  }

  view(Record: any) {
    let modalRef = this['self'].modalService.open(IstStudyTeamOrganizationViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'View',
      content: { id: Record['ID'], ApplicationID: this.ApplicationID }
    }
    modalRef.result.then(result => {
      this['self'].setSummaryData();
    })
  }

  edit(Record: any) {
    let modalRef = this['self'].modalService.open(IstStudyTeamOrganizationViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Edit',
      content: { id: Record['ID'], ApplicationID: this.ApplicationID }
    }
    modalRef.result.then(result => {
      this['self'].setSummaryData();
    })
  }


  delete() {

    let id = this['self'].selectedRow['ID'];
    var Name = this['self'].selectedRow['NAME'];
    if (this['self'].selectedRow["CREATED_BY"] != "Admin") {

      const modalRef = this['self'].modalService.open(DeleteBoxComponent, {
        backdrop: false
      })
      modalRef.componentInstance.Content = { heading: 'Delete', content: { custommessage: 'The Organization ' + "'" + Name + "'" + ' will be deleted. Do you want to proceed?', ProceedButtonName: "Yes", TerminateButtonName: "No" } }
      modalRef.result.then(result => {
        if (result == "okclick") {
          this['self'].summaryService.DeleteRecord('api/ISTOrganization/Delete?RecordID=' + id).subscribe(summary => {
            if (summary["Status"] == 0) {
              this['self'].commonService.SuccessBanner(summary["Message"]);
              this['self'].setSummaryData();
            }
            else {
              this['self'].commonService.ValidationBanner(summary["Message"]);
            }
          });
        }
      });
    }
    else {
      this['self'].commonService.ValidationBanner("Default Record can't be Deleted");
    }

  }
  IstOrggetMasterData() {
    this.organisationType = [];
    this.summaryService.getSummaryData('api/ISTOrganization/GetMasterDataSearch?ApplicationID=' + this.ApplicationID).subscribe(summary => {
      this.organisationType = summary["MasterData1"];
      this.organisationType = [{ label: "Select", value: "", checked: true }].concat(this.organisationType);     
      this.setSummaryData();
    });
  }
  setSummaryData() {
    this.SearchClear();
    if (this.ApplicationID != "" && this.ApplicationID != undefined) {
      this.summaryService.getSummaryData('api/ISTOrganization/GetSummaryData?ApplicationID=' + this.ApplicationID).subscribe(summary => {
        this.rowData = this.setOperations(summary);
      });
    }
    else {
      this.rowData = [];
    }
  }

  fetchSearchData(searchObject) {
    this.summaryService.fetchSearchData('api/ISTOrganization/GetSummarySearchData', searchObject).subscribe(summary => {
      this.rowData = this.setOperations(summary);
    });
  }

  setDef(parmoperations: any): any {
    this.operations = parmoperations.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });

    return this.operations;
  }


  setOperations(RawData: any): any {
    let tempoperations = [
      {
        "name": "View",
        "id": "view"
      },
      {
        "name": "Edit",
        "id": "edit"
      },
      {
        "name": "Delete",
        "id": "delete"
      }
    ];
    if (this.permission == "new") {
      tempoperations.push({
        "name": "Add Organization",
        "id": "add"
      });
    }

    let tempoperations2 = [
      {
        "name": "View",
        "id": "view"
      }
    ];
    if (this.permission == "new") {
      tempoperations2.push({
        "name": "Add Organization",
        "id": "add"
      });
    }

    RawData.forEach(element => {
      if (element.CREATED_BY === "Admin" || this.permission === "view") {

        element["Operations"] = this.setDef(tempoperations2);
      }
      else {

        element["Operations"] = this.setDef(tempoperations);
      }
    });

    setTimeout(()=>{
      this.gridApi.sizeColumnsToFit();
      },500);
    return RawData;
  }
  //// Advace search Functions
  SearchClear() {
    this.StudyTeamOrganization.reset();
  }
  ValidateForm() {

    var err: any = [];
    if (this.StudyTeamOrganization.valid) {
      if (
        !this.StudyTeamOrganization.controls["NAME"].value &&
        !this.StudyTeamOrganization.controls["TYPE"].value &&
        !this.StudyTeamOrganization.controls["PhoneNumber"].value
      ) {
        err.push("Please enter atleast one criteria to perform search");
        this.commonService.ValidationBanner(err);
        return false;
      }
    }
    return true;
  }

  AdvanceSearch() {
    if (this.ValidateForm()) {
      var formData = this.StudyTeamOrganization.value;
      formData["ApplicationID"] = this.ApplicationID;
      this.fetchSearchData(formData);
    }
  }
  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
      event.value = '';
    }
  }

  GetScreenConfigControls(screenCode: string) {
    this.commonService.GetScreenConfigControls(screenCode, this.ApplicationID, this.ApplicationID, (ScreenData) => {
      this.SCREEN_MODEL = ScreenData;
    });
  }

}
